/* Step 11c-3 · lane C3b — EN + AR of the screen finds of card section 4.2 (Mars live run, 31-Oct-2026).
   43: the suggested Emphasis of Matter for a posted restatement on the auditor's report (components/RestatementEomSuggest.jsx). */
export default {
  en: {
    s11c3b: {
      eomSuggest: {
        title: "Suggested Emphasis of Matter for the restatement (added only if you choose it):",
        add: "Add this Emphasis of Matter",
        added: "Emphasis of Matter added — generate the report again to include it.",
        noNote: "The restatement note's number is not known yet — fill it in on Report → EoM / OM after adding.",
      },
    },
  },
  ar: {
    s11c3b: {
      eomSuggest: {
        title: "فقرة لفت انتباه مقترحة لإعادة العرض (تُضاف فقط إذا اخترتموها):",
        add: "أضف فقرة لفت الانتباه هذه",
        added: "أُضيفت فقرة لفت الانتباه — أعيدوا إنشاء التقرير لتضمينها.",
        noNote: "رقم إيضاح إعادة العرض غير معروف بعد — أدخلوه في التقرير ← فقرات لفت الانتباه / أمور أخرى بعد الإضافة.",
      },
    },
  },
};
